import React from "react";
import { useSettings } from "_contexts/useSettings";
import "./Paragraph.scss";

function Paragraph(props) {
  const { settings } = useSettings();
  const newProps = { ...props };
  newProps.className = "pp-paragraph " + (newProps.className || "");

  const style = {
    fontFamily: settings?.secondary_font || "Geist",
    color: settings?.secondary_color || "#000",
    opacity: props.opacity || 1,
    textAlign: props.align || "center",
    fontSize: props.size || "16px",
    lineHeight: props.size === "14px" ? "21px" : "24px",
  };

  return (
    <p {...newProps} style={style}>
      {newProps.children}
    </p>
  );
}

export default Paragraph;
